export const catchError = (ex, onError) => dispatch => {
    var loaderEl = document.getElementById('genericLoader');
    if (loaderEl) {
        setTimeout(function () {
            loaderEl.classList.remove("active");
        }, 100);
    }
    if (ex.response) {
        ex.response.json().then(error => dispatch(onError(error)));
    } else {
        dispatch(onError(ex));
    }
}